import axios from 'axios';

const BACKEND_TARGET = (process.env.REACT_APP_BACKEND_TARGET || 'production').toLowerCase().trim();
const TARGET_SUFFIX = BACKEND_TARGET === 'test' ? 'TEST' : BACKEND_TARGET === 'dev' ? 'DEV' : 'PROD';

const pickEnvByTarget = (baseName, fallback = '') => {
  const direct = process.env[baseName];
  if (direct) return direct;
  const targeted = process.env[`${baseName}_${TARGET_SUFFIX}`];
  return targeted || fallback;
};

const DEFAULT_BACKEND_HOST = 'https://agent.freshroad.com';
const SOFTPHONE_BASE_URL = pickEnvByTarget('REACT_APP_SOFTPHONE_URL', `${DEFAULT_BACKEND_HOST}:3017`);

const softphoneApi = axios.create({
  baseURL: SOFTPHONE_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

softphoneApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchSoftphoneToken = async () => {
  const { data } = await softphoneApi.post('/softphone/token', {});
  if (!data?.success || !data?.token) throw new Error(data?.error || 'Could not get a softphone token');
  return data;
};

export const sendSoftphoneHeartbeat = async () => {
  const { data } = await softphoneApi.post('/softphone/heartbeat', {});
  return data;
};

export const unregisterSoftphone = () => {
  const token = localStorage.getItem('token');
  if (!token) return;
  const url = `${SOFTPHONE_BASE_URL}/softphone/unregister`;
  try {
    fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: '{}',
    });
  } catch (err) {

  }
};


export const fetchVoicemails = async () => {
  const { data } = await softphoneApi.get('/softphone/voicemails');
  if (!data?.success) throw new Error(data?.error || 'Could not load voicemails');
  return data.voicemails || [];
};

export const fetchVoicemailAudio = async (sid) => {
  const { data } = await softphoneApi.get(`/softphone/voicemails/${sid}/audio`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(data);
};

export default softphoneApi;
